import React, { PureComponent } from "react";

import SubGrid from "./SubGrid";

/**
 * The expanded band under one engagement row: its Tasks mini-grid + its Users
 * mini-grid. Rendered as a SIBLING of TrackerRow (never threaded through it) so
 * TrackerRow's PureComponent is unaffected.
 */
class EngagementSubGrids extends PureComponent {
	render() {
		const {
			engagementId,
			taskData,
			userData,
			taskLoading,
			userLoading,
			isAdmin,
			subWidths,
			subOrder,
			hiddenTaskColumns,
			onColResize,
			onColReorder,
			onNativeChange,
			onCustomChange,
			onAddRow,
		} = this.props;
		const widths = subWidths || { task: {}, user: {} };
		const order = subOrder || { task: [], user: [] };

		return (
			<div className="et-subgrids" data-eng={engagementId}>
				<SubGrid
					resource="task"
					engagementId={engagementId}
					data={taskData}
					loading={taskLoading}
					isAdmin={isAdmin}
					hiddenColumns={hiddenTaskColumns || []}
					columnWidths={widths.task || {}}
					columnOrder={order.task || []}
					onColResize={(colKey, width) => onColResize("task", colKey, width)}
					onColReorder={keys => onColReorder("task", keys)}
					onNativeChange={(recordId, field, value) => onNativeChange("task", engagementId, recordId, field, value)}
					onCustomChange={(recordId, fieldId, value) => onCustomChange("task", engagementId, recordId, fieldId, value)}
					onAddRow={payload => onAddRow("task", engagementId, payload)}
				/>
				<SubGrid
					resource="user"
					engagementId={engagementId}
					data={userData}
					loading={userLoading}
					isAdmin={isAdmin}
					columnWidths={widths.user || {}}
					columnOrder={order.user || []}
					onColResize={(colKey, width) => onColResize("user", colKey, width)}
					onColReorder={keys => onColReorder("user", keys)}
					onNativeChange={(recordId, field, value) => onNativeChange("user", engagementId, recordId, field, value)}
					onCustomChange={(recordId, fieldId, value) => onCustomChange("user", engagementId, recordId, fieldId, value)}
					onAddRow={payload => onAddRow("user", engagementId, payload)}
				/>
			</div>
		);
	}
}

export default EngagementSubGrids;
